import React from 'react';
import PropTypes from 'prop-types';

import Button from '@ublend-npm/aulaui-next-web/Button';
import AddIcon from '@material-ui/icons/Add';

import GroupSetsList from './GroupSetsList.container';
import FilterRow from './FilterRow.styled';
import {
  CreateGroupSetDialog,
  EditGroupSetDialog,
} from './CreateEditGroupSetDialog';
import { CreateGroupDialog, EditGroupDialog } from './CreateEditGroupDialog';
import AutoGenerateGroupDialog from './AutoGenerateGroupDialog';

import pointer, { newSetButton, GroupsContent } from './GroupsTab.styled';
import withErrorBoundary from '../../common/ErrorBoundary/ErrorBoundary';

const GroupsTab = ({ isInstructor, noGroupSets, onCreateSet }) => {
  const pointerIcon = noGroupSets ? (
    <span className={pointer} role="img" aria-label="Point up">
      👆
    </span>
  ) : null;

  const createGroupSetButton = isInstructor ? (
    <React.Fragment>
      <FilterRow>
        <Button
          className={`new-set-button ${newSetButton}`}
          type="primary"
          size="small"
          iconLeft={AddIcon}
          onClick={onCreateSet}
        >
          New set of groups
          {pointerIcon}
        </Button>
      </FilterRow>
    </React.Fragment>
  ) : null;

  return (
    <GroupsContent id="space-settings-groups">
      {createGroupSetButton}
      <GroupSetsList />
      <CreateGroupSetDialog />
      <EditGroupSetDialog />
      <CreateGroupDialog />
      <EditGroupDialog />
      <AutoGenerateGroupDialog />
    </GroupsContent>
  );
};

GroupsTab.propTypes = {
  isInstructor: PropTypes.bool.isRequired,
  noGroupSets: PropTypes.bool.isRequired,
  onCreateSet: PropTypes.func.isRequired,
};

export default withErrorBoundary(
  GroupsTab,
  'Something went wrong in the Groups tab.'
);
